import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, normalizeProps as _normalizeProps, guardReactiveProps as _guardReactiveProps, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("path", { d: "M15 18H16.5C17.8807 18 19 16.8807 19 15.5C19 14.1193 17.8807 13 16.5 13H3V11H16.5C18.9853 11 21 13.0147 21 15.5C21 17.9853 18.9853 20 16.5 20H15V22L11 19L15 16V18ZM3 4H21V6H3V4ZM9 18V20H3V18H9Z" }, null, -1)
const _hoisted_2 = [
  _hoisted_1
]

import { iconAttributes } from '@/utils/icons';


export default /*#__PURE__*/_defineComponent({
  __name: 'TextWrap',
  setup(__props) {

const attrs = iconAttributes({ width: 24, height: 24 });

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("svg", _normalizeProps(_guardReactiveProps(_unref(attrs))), _hoisted_2, 16))
}
}

})